(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ems-mobile-purchase"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ems-mobile-purchase'))customElements.define('ems-mobile-purchase',class extends HTMLElement{
connectedCallback(){this.dockButton=this.querySelector('button');this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);this.errorLink=document.createElement('button');this.errorLink.type='button';this.errorLink.className='ems-mobile-buy__error';this.errorLink.hidden=true;this.errorClick=()=>{this.form.closest('product-form').scrollIntoView({behavior:'smooth',block:'center'});this.source.focus({preventScroll:true});};this.errorLink.addEventListener('click',this.errorClick);this.append(this.errorLink);this.bind=this.bind.bind(this);this.click=()=>{const form=this.form;if(form&&this.source&&!this.source.disabled&&this.source.getAttribute('aria-disabled')!=='true'&&!this.source.classList.contains('loading'))form.requestSubmit(this.source);};this.dockButton.addEventListener('click',this.click);this.bind();this.onSection=()=>this.bind();document.addEventListener('shopify:section:load',this.onSection);}
bind(){this.form?.removeEventListener('change',this.change);this.observer?.disconnect();this.intersection?.disconnect();this.form=document.querySelector('product-form form[id^="product-form-"]');this.source=this.form?.querySelector('[name="add"]');if(!this.source){this.hidden=true;return;}this.visible=true;const sync=()=>{const variant=this.variants.find(v=>String(v.id)===String(this.form.querySelector('[name="id"]')?.value));this.dockButton.disabled=this.source.disabled||this.source.getAttribute('aria-disabled')==='true'||this.source.classList.contains('loading');this.dockButton.setAttribute('aria-busy',this.source.classList.contains('loading')?'true':'false');this.dockButton.textContent=this.source.querySelector('span')?.textContent.trim()||this.source.textContent.trim();if(variant)this.querySelector('.ems-mobile-buy__price').textContent=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(variant.price/100);const error=this.form.closest('product-form')?.querySelector('.product-form__error-message-wrapper:not([hidden])');this.hidden=this.visible;this.errorLink.hidden=!error;this.errorLink.textContent=error?this.dataset.errorLabel:'';};this.observer=new MutationObserver(sync);this.observer.observe(this.form.closest('product-form'),{subtree:true,attributes:true,childList:true,characterData:true});this.intersection=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;sync();});this.intersection.observe(this.source);this.change=sync;this.form.addEventListener('change',sync);sync();}
disconnectedCallback(){this.observer?.disconnect();this.intersection?.disconnect();this.form?.removeEventListener('change',this.change);document.removeEventListener('shopify:section:load',this.onSection);this.dockButton?.removeEventListener('click',this.click);this.errorLink?.removeEventListener('click',this.errorClick);this.errorLink?.remove();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ems-product-events"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ems-product-events'))customElements.define('ems-product-events',class extends HTMLElement{
connectedCallback(){this.click=(event)=>{const link=event.target.closest('a[href="#open-chatway"]');if(link)this.publish('ems:product_chat_clicked');};this.submit=(event)=>{if(event.target.closest('.ems-selection'))this.publish('ems:pump_advice_requested');else if(event.target.closest('product-form'))this.publish('ems:add_to_cart_clicked');};this.success=()=>{if(document.querySelector('.ems-selection__success'))this.publish('ems:pump_advice_confirmation_viewed');};document.addEventListener('click',this.click);document.addEventListener('submit',this.submit);this.success();}
publish(name){if(!window.Shopify?.analytics?.publish)return;try{Promise.resolve(window.Shopify.analytics.publish(name,{product_id:this.dataset.productId,product_title:this.dataset.productTitle,page_path:location.pathname})).catch(()=>{});}catch(e){}}
disconnectedCallback(){document.removeEventListener('click',this.click);document.removeEventListener('submit',this.submit);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ems-product-extras"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const link=event.target.closest('[data-ems-product-chat]');if(!link)return;const api=window.$chatway;if(api&&typeof api.updateChatwayCustomData==='function'){api.updateChatwayCustomData('product_name',link.dataset.title);api.updateChatwayCustomData('product_url',link.dataset.url);}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ems-pump-schematic"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ems-pump-schematic'))customElements.define('ems-pump-schematic',class extends HTMLElement{
connectedCallback(){this.zoom=100;this.canvas=this.querySelector('.ems-schematic__canvas');this.toolbar=this.querySelector('.ems-schematic__toolbar');this.toolbar.hidden=false;this.searchBox=this.querySelector('.ems-schematic__search');this.searchBox.hidden=false;this.search=this.searchBox.querySelector('input');this.rows=Array.from(this.querySelectorAll('tbody tr'));this.zoomClick=(event)=>{const button=event.target.closest('[data-zoom]');if(!button)return;this.zoom=button.dataset.zoom==='reset'?100:Math.min(300,Math.max(100,this.zoom+(button.dataset.zoom==='in'?50:-50)));this.canvas.style.width=this.zoom+'%';this.toolbar.querySelector('output').textContent=this.zoom+'%';this.toolbar.querySelector('[data-zoom="out"]').disabled=this.zoom===100;this.toolbar.querySelector('[data-zoom="in"]').disabled=this.zoom===300;};this.filter=()=>{const term=this.search.value.trim().toLocaleLowerCase();let visible=0;this.rows.forEach(row=>{row.hidden=!row.textContent.toLocaleLowerCase().includes(term);if(!row.hidden)visible++;});this.querySelector('.ems-schematic__empty').hidden=visible>0;};this.selectPart=(event)=>{const link=event.target.closest('.ems-schematic__hotspot');if(!link||!link.getAttribute('href').startsWith('#'))return;const row=this.querySelector(link.getAttribute('href'));if(!row)return;this.search.value='';this.filter();row.focus({preventScroll:true});};this.addEventListener('click',this.selectPart);this.toolbar.addEventListener('click',this.zoomClick);this.search.addEventListener('input',this.filter);this.toolbar.querySelector('[data-zoom="out"]').disabled=true;this.editorSelect=(event)=>{const selected=event.target.closest('.ems-schematic__hotspot');if(selected)selected.scrollIntoView({block:'nearest',inline:'nearest'});};this.addEventListener('shopify:block:select',this.editorSelect);}
disconnectedCallback(){this.removeEventListener('click',this.selectPart);this.toolbar?.removeEventListener('click',this.zoomClick);this.search?.removeEventListener('input',this.filter);this.removeEventListener('shopify:block:select',this.editorSelect);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ems-schematics-header"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ems-schematic-library'))customElements.define('ems-schematic-library',class extends HTMLElement{
connectedCallback(){this.labels=this.querySelector('[data-labels]').dataset;this.input=this.querySelector('input');this.results=this.querySelector('.ems-library__results');this.status=this.querySelector('[role="status"]');this.empty=this.querySelector('.ems-library__empty');this.empty.dataset.defaultText=this.empty.textContent;this.backButton=this.querySelector('[data-back]');this.form=this.querySelector('form');this.normalize=value=>value.toLocaleLowerCase().replace(/[^a-z0-9]/g,'');this.search=()=>{this.selected=null;this.showResults();const url=new URL(location.href);if(url.searchParams.has('model')){url.searchParams.delete('model');history.replaceState(null,'',url);}};this.submit=event=>{event.preventDefault();this.search();};this.click=event=>{const card=event.target.closest('[data-machine-id]');if(card){this.select(card.dataset.machineId,true);return;}if(event.target.closest('[data-browse]')||event.target.closest('[data-back]')){this.input.value='';this.search();this.input.focus();}};this.build=()=>{this.machines=Array.from(document.querySelectorAll('ems-pump-schematic[data-machine-name]'));this.querySelector('.ems-library__controls').hidden=false;this.showResults();};this.form.addEventListener('submit',this.submit);this.input.addEventListener('input',this.search);this.addEventListener('click',this.click);this.editorLoad=()=>this.build();document.addEventListener('shopify:section:load',this.editorLoad);this.editorSelect=event=>{const machine=event.target.closest('.shopify-section')?.querySelector('ems-pump-schematic');if(machine){this.select(machine.id,false);}};document.addEventListener('shopify:section:select',this.editorSelect);this.ready=()=>{this.build();const model=new URL(location.href).searchParams.get('model');if(model){this.input.value=model;const matches=this.machines.filter(m=>this.normalize(m.dataset.modelNumber)===this.normalize(model));if(matches.length===1)this.select(matches[0].id,false);else this.showResults();}};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',this.ready,{once:true});else this.ready();}
showResults(){if(!this.machines)return;const term=this.input.value.trim();const compact=this.normalize(term);const words=term.toLocaleLowerCase().split(/\s+/).filter(Boolean).map(this.normalize);this.machines.forEach(m=>m.hidden=true);this.backButton.hidden=true;this.results.hidden=false;this.results.replaceChildren();const matches=this.machines.filter(m=>{const haystack=this.normalize([m.dataset.machineName,m.dataset.modelNumber,m.dataset.searchTerms,m.dataset.machineHeading].join(' '));return !compact||haystack.includes(compact)||words.every(word=>haystack.includes(word));});matches.sort((a,b)=>Number(this.normalize(b.dataset.modelNumber)===compact)-Number(this.normalize(a.dataset.modelNumber)===compact));this.status.textContent=String(matches.length)+' '+this.results.getAttribute('aria-label').toLocaleLowerCase();this.empty.hidden=matches.length>0;this.empty.textContent=this.machines.length?this.empty.dataset.defaultText||this.empty.textContent:this.labels.empty;if(!this.empty.dataset.defaultText&&this.machines.length)this.empty.dataset.defaultText=this.empty.textContent;for(const machine of matches){const card=document.createElement('article');card.className='ems-library__card';const img=document.createElement('img');img.src=machine.dataset.machineImage;img.alt='';img.loading='lazy';img.width=600;img.height=400;const heading=document.createElement('h2');heading.textContent=machine.dataset.machineName;const model=document.createElement('p');model.textContent=this.labels.model+': '+(machine.dataset.modelNumber||machine.dataset.machineHeading);const button=document.createElement('button');button.type='button';button.dataset.machineId=machine.id;button.textContent=this.labels.open;button.setAttribute('aria-label',this.labels.open+': '+machine.dataset.machineName);card.append(img,heading,model,button);this.results.append(card);}}
select(id,updateUrl){const machine=this.machines?.find(m=>m.id===id);if(!machine)return;this.machines.forEach(m=>m.hidden=m!==machine);this.selected=id;this.results.hidden=true;this.empty.hidden=true;this.backButton.hidden=false;this.status.textContent=this.labels.selected+': '+machine.dataset.machineName;const heading=machine.querySelector('h2');heading.tabIndex=-1;heading.focus({preventScroll:true});machine.scrollIntoView({behavior:'smooth',block:'start'});if(updateUrl&&machine.dataset.modelNumber){const url=new URL(location.href);url.searchParams.set('model',machine.dataset.modelNumber);history.replaceState(null,'',url);}}
disconnectedCallback(){this.form?.removeEventListener('submit',this.submit);this.input?.removeEventListener('input',this.search);this.removeEventListener('click',this.click);document.removeEventListener('DOMContentLoaded',this.ready);document.removeEventListener('shopify:section:load',this.editorLoad);document.removeEventListener('shopify:section:select',this.editorSelect);this.machines?.forEach(m=>m.hidden=false);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ems-well-main-ai"] && !Shopify.designMode) return;
  try {
    
(() => {
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-ai"] && !Shopify.designMode) return;
  try {
    
(() => {
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sump-main-ai"] && !Shopify.designMode) return;
  try {
    
(() => {
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sump-product-extras"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const link=event.target.closest('[data-ems-product-chat]');if(!link)return;const api=window.$chatway;if(api&&typeof api.updateChatwayCustomData==='function'){api.updateChatwayCustomData('product_name',link.dataset.title);api.updateChatwayCustomData('product_url',link.dataset.url);}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["well-ems-product-events"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ems-product-events'))customElements.define('ems-product-events',class extends HTMLElement{
connectedCallback(){this.click=(event)=>{const link=event.target.closest('a[href="#open-chatway"]');if(link)this.publish('ems:product_chat_clicked');};this.submit=(event)=>{if(event.target.closest('.ems-selection'))this.publish('ems:pump_advice_requested');else if(event.target.closest('product-form'))this.publish('ems:add_to_cart_clicked');};this.success=()=>{if(document.querySelector('.ems-selection__success'))this.publish('ems:pump_advice_confirmation_viewed');};document.addEventListener('click',this.click);document.addEventListener('submit',this.submit);this.success();}
publish(name){if(!window.Shopify?.analytics?.publish)return;try{Promise.resolve(window.Shopify.analytics.publish(name,{product_id:this.dataset.productId,product_title:this.dataset.productTitle,page_path:location.pathname})).catch(()=>{});}catch(e){}}
disconnectedCallback(){document.removeEventListener('click',this.click);document.removeEventListener('submit',this.submit);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["well-ems-product-extras"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const link=event.target.closest('[data-ems-product-chat]');if(!link)return;const api=window.$chatway;if(api&&typeof api.updateChatwayCustomData==='function'){api.updateChatwayCustomData('product_name',link.dataset.title);api.updateChatwayCustomData('product_url',link.dataset.url);}});

  } catch(e) { console.error(e); }
})();
})();
